export default {
    header: {},
    footer: {},
    editorData:""
}
